import React from "react";
import { Stack, Typography } from "@mui/material";
import { connect } from "react-redux";

import { getUserLocation } from "../../redux/auth";
import { INDUSTRIES, FOUNDRIES } from "../../constants/industry";

import {
  HubHookFormInput,
  HubHookFormSelect,
  HubHookFormTagInput,
  IndustryHookFormSelect,
} from "../../components";
import { RANKS } from "../../constants/customers";

const CreateCompanyDetails = ({ isVendor, disabled }) => {
  return (
    <Stack gap="15px" width="100%">
      <Typography variant="boldCaptionMain">
        {isVendor ? "Vendor" : "Customer"} Details
      </Typography>
      <Stack
        direction="row"
        gap="10px"
        alignItems="center"
        justifyContent="center"
      >
        <HubHookFormInput
          name="customerName"
          label={isVendor ? "Vendor" : "Customer"}
          placeholder="IPC Foundry Group"
          disableHelperText
          disabled={disabled}
          required
        />
        {isVendor ? (
          <HubHookFormSelect
            name="ranking"
            label="Ranking"
            options={RANKS}
            sx={{ flexGrow: "1" }}
            defaultValue={1}
            disabled={disabled}
            disableHelperText
            required
          />
        ) : (
          <IndustryHookFormSelect
            name="industry"
            label="Industry"
            placeholder="ex. Oil"
            sx={{ flexGrow: "1" }}
            disabled={disabled}
            disableHelperText
            required
          />
        )}
      </Stack>
      <HubHookFormTagInput
        name="locations"
        label="Foundries"
        options={FOUNDRIES}
        disabled={disabled}
        disableHelperText
        required
      />
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  userLocation: getUserLocation(state),
});
export default connect(mapStateToProps)(CreateCompanyDetails);
